//
//
//
//
//
//
//

export default {
  name: 'App',
  data() {
    return {
      
    };
  },
  mounted()
  {
    
  },
  methods:{
    

  }
}



// WEBPACK FOOTER //
// ./src/App.vue